import { createI18n } from "vue-i18n";
import { watch } from "vue";
import en from "./locales/en.json";
import jp from "./locales/jp.json";
import ar from "./locales/ar.json";
import es from "./locales/es.json";
import pt from "./locales/pt.json";
import kr from "./locales/kr.json";
import zh from "./locales/zh.json";
import { getCookie, setCookie } from "@/utils/cookieUtils";

const COOKIE_NAME = "user_locale";
const DEFAULT_LOCALE = "en";

const savedLocale = getCookie(COOKIE_NAME) || DEFAULT_LOCALE;

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: "en",
  messages: {
    en,
    jp,
    ar,
    es,
    pt,
    kr,
    zh
  }
});

watch(
  () => i18n.global.locale.value, // Watch the `locale` property
  (newLocale) => {
    // Update the cookie whenever the locale changes
    setCookie(COOKIE_NAME, newLocale, 365);
  }
);

export default i18n;
